import * as React from 'react';
import __ from '@vitafy/common-libraries/frontend/Translate';

type ReviewProps = {
  nickName: string;
  product: string;
  createdAt: string;
  rating_votes: number;
  detail: string;
  locale: string;
  title?: string;
  verified_customer_score?: boolean;
};

const Review: React.FC<ReviewProps> = ({
  nickName,
  createdAt,
  rating_votes,
  detail,
  locale,
  title,
  verified_customer_score,
  product
}) => {
  return (
    <article className="block">
      <div className="row">
        <div className="medium-3 large-2 columns">
          <header>
            <span className={`username text-subtle ${verified_customer_score ? 'username--verified' : ''}`}>
              {nickName} &nbsp;
              {!!verified_customer_score && (
                <span className="user-attribute--verified">
                  {__({
                    val: 'Verified',
                    locale
                  })}
                </span>
              )}
            </span>
            <div className="rating-box rating-bottom-margin db">
              <div className="rating" style={{ width: `${(100 / 5) * rating_votes}%` }} />
            </div>
          </header>
        </div>
        <div className="medium-9 large-10 columns">
          <strong>{title}</strong>
          <p className="mtn">{detail}</p>
          <small className="text-subtle">
            {__({
              val: 'Customer review from %s',
              locale,
              substitution: [createdAt]
            })}{' '}
            {product ? ` - ${product}` : ''}
          </small>
        </div>
      </div>
    </article>
  );
};

export default Review;
